import React from 'react'
import { Link } from "react-router-dom";
import { RiGovernmentLine } from "react-icons/ri";
// Removed unused TbHexagonalPyramid icon import
import { MdOutlineEventAvailable } from "react-icons/md";
// Removed unused FaRegCalendarCheck, FaEye, FaCalendarAlt icon imports
import { MdOutlineManageHistory } from "react-icons/md";
import { IoCreateSharp } from "react-icons/io5";
// Removed other unused icon imports
import { FaListAlt } from "react-icons/fa";
import Langfield from "../../assets/Json/dashboardJson.json";
import { useSelector } from 'react-redux';
// Removed unused GiTurban import
// Removed language selection imports and related utils, modal, and SelectLang component


function SideBar({
  index
}) {
  const langSelected2 = useSelector(state => state.auth.user.lang);
  // const userData = useSelector(state => state.auth.user); // Unused in sidebar
  // Removed language selection state
  
  console.log(langSelected2,"langselected2")
  const translations = Langfield[langSelected2];

  // const [storeLang, setStoreLang] = useState('en-IN');
  const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== 'object' || translations === null) {
        return key; // Return the key if translations is not available
    }

    // Handle undefined or non-string keys
    if (typeof key !== 'string') {
        return key; // Return the value as is if key is not a string
    }

  return translations[key] || key.replace(/_/g, ' '); // Use translation or fallback to the key
};

  // Language selection and modal confirmation removed


  return (
    <>
    <div className="schlDashbrdLft">
      <ul>
        <li><Link to="/faculty" className={`${index === 0 ? 'activeLnk' : ''}`}><RiGovernmentLine /> {translate("Dashboard")}</Link></li>
        <li><Link to="/faculty/createtheme" className={`${index === 1 ? 'activeLnk' : ''}`} ><IoCreateSharp />{translate("Create_Event")}</Link></li>
        <li><Link to="/faculty/eventmanagement" className={`${index === 2 ? 'activeLnk' : ''}`}><MdOutlineManageHistory />{translate("Event_Management")}</Link></li>
        {/* <li>
          <Link to="/faculty/VeerBalDiwas" className={`${index === 9 ? 'activeLnk' : ''}`}><GiTurban /> Veer Bal Diwas </Link>
          </li> */}
        <li><Link to="/faculty/eventlist" className={`${index === 3 ? 'activeLnk' : ''}`}><FaListAlt />{translate("Event_List")}</Link></li>
        <li><Link to="/faculty/ecocalendar" className={`${index === 4 ? 'activeLnk' : ''}`}><MdOutlineEventAvailable />{translate("Eco_Calender")}</Link></li>
        
        {/* Language selection removed from faculty sidebar */}
          
        {/* <SelectLang /> */}
      </ul>
    </div>

    {/* Modal for language selection removed */}
    </>
  )
}

export default SideBar